import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { authAPI } from '../../api';
import '../../styles/AuthModal.css'; // Reusing some styles

const ConfirmationPage = () => {
    const { token } = useParams();
    const [status, setStatus] = useState('loading'); // loading, success, error
    const [message, setMessage] = useState('Confirmando sua conta...');

    useEffect(() => {
        const confirmAccount = async () => {
            if (!token) {
                setStatus('error');
                setMessage('Token de confirmação não encontrado.');
                return;
            }

            try {
                // The backend redirects on success, so we just need to make the call
                // and handle potential errors if the redirect doesn't happen or fails.
                await authAPI.confirmAccount(token);
                setStatus('success');
                setMessage('Sua conta foi confirmada com sucesso! Você já pode fazer login.');
            } catch (err) {
                console.error('Erro ao confirmar conta:', err);
                setStatus('error');
                setMessage(err.message || 'Ocorreu um erro ao confirmar sua conta. O token pode ser inválido ou ter expirado.');
            }
        };

        confirmAccount();
    }, [token]);

    return (
        <div className="auth-modal-overlay" style={{ position: 'relative', height: '100vh' }}>
            <div className="auth-modal" style={{ top: '50%', transform: 'translate(-50%, -50%)' }}>
                <div className="auth-header">
                    <h2>Confirmação de Conta</h2>
                </div>

                {status === 'loading' && (
                    <div className="auth-message">
                        <p>{message}</p>
                        <div className="spinner"></div> {/* Add a simple spinner */}
                    </div>
                )}

                {status === 'success' && (
                    <div className="auth-success">
                        <p>{message}</p>
                        <Link to="/" className="auth-submit">Ir para o Login</Link>
                    </div>
                )}

                {status === 'error' && (
                    <div className="auth-error">
                        <p>{message}</p>
                        <Link to="/" className="auth-submit">Voltar para o Início</Link>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ConfirmationPage;
